import { render, staticRenderFns } from "./IntroduceEdit.vue?vue&type=template&id=030f1e3c&scoped=true"
import script from "./IntroduceEdit.vue?vue&type=script&lang=js"
export * from "./IntroduceEdit.vue?vue&type=script&lang=js"
import style0 from "./IntroduceEdit.vue?vue&type=style&index=0&id=030f1e3c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "030f1e3c",
  null
  
)

export default component.exports